/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import ErrorPage from '../error/ErrorPage';
import { SnackbarHandler } from './SnackbarHandler';
import LogTracker from '../errorTracking/LogTracker';

/**
 * Alerts class which implements the error boundary functionality from react
 * https://reactjs.org/docs/error-boundaries.html
 */
export default class Alerts extends React.Component {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidMount() {
    // Add an event listener to the window to catch unhandled promise rejections & stash the error in the state
    window.addEventListener('unhandledrejection', this.promiseRejectionHandler);
    LogTracker.init();
  }

  componentWillUnmount() {
    // Remove the added event listener
    window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
  }

  promiseRejectionHandler = (event) => {
    this.setState({ error: event.reason });
    return this.tracker && this.tracker.captureException(event);
  };

  render() {
    return (
      <SnackbarHandler>
        {this.state.error ? <ErrorPage error={this.state.error} /> : this.props.children}
      </SnackbarHandler>
    );
  }
}
